import { AgentEmailPreferenceSetting } from './agent-email-preference-setting';
import { EmailSection } from './email-section';
import { EmailSectionGroup } from './email-section-group';
import { Role } from './role';

export class ViewUserNotificationCategory {
	public id: number;
	public name: string;
	public description: string;
	public sortOrder: number;
	public emailPreferenceSettingId: number;
	public userNotificationCategoryCollectionId: number;
	public userNotificationCategoryCollectionName: string;
	public userNotificationCategoryCollectionDescription: string;
	public emailPreferenceTypeId: number;
	public emailPreferenceSettingTargetDateOptionId: number;
	public emailPreferenceType: string;
	public targetDateTypeOption: string;
	public sendDelayDirection: number;
	public sendDelay: number;
	public sendFrequency: number;
	public holidayTypeId: number;
	public holidayType: string;
	public hasSections: boolean;
	public isAdminOnly: boolean;
	public isUSOnly: boolean;
	public isMandatory: boolean;
	public userNotificationCategorySetId: number;
	public userNotificationCategoryCampaignId: number;
	public emailCampaignLeadTypeId: number;
	public thImgPath: string;
	public fullImgPath: string;
	public isBrokerLevel: boolean;
	public isCustomerLevel: boolean;
	public isLeadLevel: boolean;

	public agentEmailPreferenceSetting: AgentEmailPreferenceSetting;
	public emailSections: EmailSection[];
	public roles: Role[];

	// internal grouping
	public emailSectionGroups?: EmailSectionGroup[];

	constructor(viewUserNotificationCategory?: ViewUserNotificationCategory) {
		Object.assign(this, viewUserNotificationCategory);
	}
}
